import { useTransition } from '../../../hooks/useTransition';

const AnimatedStepItem = ({
  children,
  show,
  animateState
}: {
  children?: React.ReactNode;
  show?: boolean;
  animateState?: string;
}) => {
  const { className } = useTransition(Boolean(show));

  if (!show) return null;

  return (
    <div className={[className, 'animate-step-item', animateState].join(' ')}>
      {children}
    </div>
  );
};

export { AnimatedStepItem };
